// extracted by mini-css-extract-plugin
module.exports = {"arrow-decoration":"arrow-decoration_arrow-decoration__JcjDb"};